import useTranslation from 'next-translate/useTranslation';
import LinkTranslated from '@/components/Translator/LinkTranslated';
import { JSX } from 'react';

interface ForBlockProps {
  text: string;
  blocks: Block[];
}

type Block = {
  title: string;
  icon: JSX.Element;
};

interface ForSectionProps {
  sellText: string;
  buyText: string;
  sellerBlocks: Block[];
  buyerBlocks: Block[];
}

function SellerForBlock({ text, blocks }: ForBlockProps) {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col justify-between rounded-lg bg-orange-50 p-5 '>
      <div className='flex flex-col gap-3'>
        <div className='text-lg font-semibold text-black '>
          {t('services:For Sellers')}
        </div>
        <div className=' text-black'>{text}</div>
      </div>
      <div className='flex justify-center'>
        <div className='flex flex-col gap-3'>
          {blocks.map((blockText, index) => (
            <div key={index}>
              <div className='flex items-center '>
                <div className='flex items-center gap-3'>
                  <div className='flex items-center justify-center rounded-full bg-orange-100 p-1  text-orange-400'>
                    {blockText['icon']}
                  </div>
                  <div className='font-medium'>{blockText['title']}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='flex items-center justify-end '>
        <LinkTranslated
          href={'/sell'}
          aProps={{
            className:
              'text-orange-400 py-2 font-medium border-orange-400 border-2 rounded-lg flex items-center hover:bg-orange-400 hover:text-white w-full justify-center',
          }}
        >
          {t('Sell')}
        </LinkTranslated>
      </div>
    </div>
  );
}
function BuyerForBlock({ text, blocks }: ForBlockProps) {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col justify-between gap-5 rounded-lg bg-slate-100 p-5'>
      <div className='flex flex-col gap-3'>
        <div className='text-lg font-semibold text-black '>
          {t('services:For Buyers')}
        </div>
        <div className=' text-black'>{text}</div>
      </div>
      <div className='flex justify-center'>
        <div className='flex flex-col gap-3'>
          {blocks.map((blockText, index) => (
            <div key={index} className={``}>
              <div className='flex items-center justify-between '>
                <div className='flex items-center gap-3'>
                  <div className='flex items-center justify-center rounded-full bg-slate-200 p-1 text-slate-900'>
                    {blockText['icon']}
                  </div>
                  <div className='font-medium'>{blockText['title']}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='flex items-center justify-end '>
        <LinkTranslated
          href={'/buy'}
          aProps={{
            className:
              'text-slate-900 py-2 font-medium px-8 border-slate-900 border-2 rounded-lg flex items-center hover:bg-slate-900 hover:text-white w-full justify-center',
          }}
        >
          {t('Buy')}
        </LinkTranslated>
      </div>
    </div>
  );
}

function ForSection({
  sellText,
  buyText,
  sellerBlocks,
  buyerBlocks,
}: ForSectionProps) {
  return (
    <div className=' space-y-6 md:!mb-8'>
      <div className='grid grid-cols-1 gap-x-10 gap-y-8 md:grid-cols-2'>
        <SellerForBlock text={sellText} blocks={sellerBlocks} />
        <BuyerForBlock text={buyText} blocks={buyerBlocks} />
      </div>
    </div>
  );
}

export default ForSection;
